import { Box, Skeleton, Typography } from "@mui/material";
import { OcChartSummaryProps } from "./chart-summary";
import { useOcChartSummary } from "./use-chart-summary";
import { PRODUCTS } from "oc/configs/constants";

type OcChartSummaryViewProps = OcChartSummaryProps &
  ReturnType<typeof useOcChartSummary>;

export const OcChartSummaryView: React.FC<OcChartSummaryViewProps> = ({
  summaryText,
  summaryTitle,
  variant,
  loading,
  subtextStyle,
  titleStyle,
}) => {
  return (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100%",
        pointerEvents: "none",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          paddingTop: "16px",
          pointerEvents: "auto",
        }}
      >
        {!loading ? (
          <>
            <Typography {...titleStyle}>{summaryTitle}</Typography>
            {variant === PRODUCTS.MYCAFETERIA && <Box height="16px" />}
            <Typography {...subtextStyle}>{summaryText}</Typography>
          </>
        ) : (
          <>
            <Skeleton
              variant="rectangular"
              sx={{
                width: variant === PRODUCTS.MYCAFETERIA ? "120px" : "36px",
                height: variant === PRODUCTS.MYCAFETERIA ? "20px" : "36px",
                margin: "4px 0px",
              }}
            />
            <Skeleton
              variant="rectangular"
              sx={{
                width: "71px",
                height: variant === PRODUCTS.MYCAFETERIA ? "16px" : "25px",
                margin:
                  variant === PRODUCTS.MYCAFETERIA ? "16px 0px" : "2px 0px",
              }}
            />
            {variant === PRODUCTS.MYLEAVE && (
              <Skeleton
                variant="rectangular"
                sx={{
                  width: "71px",
                  height: "25px",
                  margin: "2px 0px",
                }}
              />
            )}
          </>
        )}
      </Box>
    </Box>
  );
};
